import React from "react";
import styles from "./dashboard/Styles";
import {
  GET_ONE,
  GET_LIST,
  UPDATE,
  SimpleForm,
  FunctionField,
  Responsive,
  SaveButton,
  showNotification,
} from "react-admin";

import { GET_MANY } from "ra-core";
import { connect } from "react-redux";
import { change, submit } from "redux-form";
import moment from "moment";
import styled from "styled-components";
import { withStyles } from "@material-ui/core/styles";
import dataProviderFactory from "../dataProvider";

import {
  Card,
  Select,
  MenuItem,
  InputLabel,
  TextField,
  FormControlLabel,
  Switch,
  CardContent,
  Typography,
  LinearProgress,
  Checkbox,
  Grid,
} from "@material-ui/core";

import {
  map,
  length,
  head,
  filter,
  prop,
  propEq,
  find,
  isNil,
  curry,
  path,
  sum,
} from "ramda";
import { isNull } from "util";
import * as R from "ramda" 
import moment_tz from 'moment-timezone';
import { RestaurantRounded } from "@material-ui/icons";
import { DATEFORMAT } from "../date-config";
import { getPermissionRole } from "../util";
import {
  normalizeInsuranceId,
  isPaidInsurance,
  resolveApplicableInsuranceId,
  insuranceLabel,
  insuranceSelectChoices,
  dailyInsurancePriceFromList,
  INSURANCE_REGULAR,
} from "../util/rentalInsurance";

const StyledSelect = styled(Select)`
  width: 256px !important;
`;

const StyledSpan = styled.div`
  color: red;
  padding: 10px;
  width: 100% !important;
`;
const StyledP = styled(FunctionField)`
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100% !important;
`;
let rentalTotal1 = 0;
var notifiGps = false, notifiSingle = false, notifiVip = false, notifiSeguroCancel = false
class ProcessTour extends React.Component {
  state = {
    value_to_charge: 0,
    clientRewards: 0,
    r_insurance_disabled: false,
    r_gps_disabled: false,
    isOnSubmit: false,
    discount: 0,
    driver_id: 0,
    comments: "",
    imt_comment: "",
    r_cancel_insurance: false, cancelInsuranceValue: 0, cancelInsurancePercentage: 0,
    low_seat: false,
    r_single: false,
    chargeTypeId: "2",
    location_id_1: 0,
    location_id_2: 0,
    time_1: 0,
    time_2: 0,
    date_1: null,
    date_2: null,
    r_gps: false,
    rewards: 0,
    r_insurance: false,
    r_insurance_id: INSURANCE_REGULAR,
    vehicle_model_1: 0,
    vehicle_model_2: 0,
    vehicleId: 0,
    gpsDeviceId: 0,
    rental: null,
    checkedF: false,
    error: false,
    noConfirmationEmail: false,
    priceDate: null,
  };

  async getGpsDevices() {
    const { rental } = this.state;
    const dataProvider = await dataProviderFactory("rest");
    const responseGps = await dataProvider(GET_LIST, "gps_devices", {
      filter: {
        tour_id: rental.booking.tour_id,
        availability: true,
      },
      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: { field: "order", order: "ASC" },
    });
    return responseGps;
  }

  async getAvailableRewards(id) {
    const dataProvider = await dataProviderFactory("rest");
    const client = await dataProvider(GET_ONE, "clients", { id });
    const data = path(["data", "availableRewards"], client);
    return data;
  }

  async gpsPrices(date) {
    const dataProvider = await dataProviderFactory("rest");
    const gpsPrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        price_item_type: "gps_device",
        for_date: date,
      },

      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: { field: "start_date", order: "DESC" },
    });
    return gpsPrices;
  }

  async getTourPrices(tourId, date) {
    const dataProvider = await dataProviderFactory("rest");
    const responseTourPrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        for_date: date,
        for_tour_id: tourId,
      },
      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: {}
    });
    return responseTourPrices;
  }

  async insurancePrices(date) {
    const dataProvider = await dataProviderFactory("rest");
    const insurancePrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        price_item_type: "insurance",
        for_date: date,
      },

      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: { field: "start_date", order: "DESC" },
    });
    return insurancePrices;
  }

  getModelName1() {
    const { models, vehicle_model_1 } = this.state;
    const selectedModel = head(filter(propEq("id", vehicle_model_1), models));
    return selectedModel.model_name;
  }

  getModelName2() {
    const { models, vehicle_model_2 } = this.state;
    const selectedModel = head(filter(propEq("id", vehicle_model_2), models));
    return selectedModel.model_name;
  }

  async getModelPrices1() {
    const { models, tourPrices, vehicle_model_1 } = this.state;
    const selectedModel = head(filter(propEq("id", vehicle_model_1), models));

    if (selectedModel.model_name === "Own Motorcycle") {
      return 0;
    }

    const selectedUpPrice = head(
      filter(
        propEq("price_item_sub_type", `tour_${selectedModel.upgrade_type}`),
        tourPrices
      )
    );
    return selectedUpPrice.price;
  }

  async getModelPrices2() {
    const { models, tourPrices, vehicle_model_2 } = this.state;
    const selectedModel = head(filter(propEq("id", vehicle_model_2), models));

    if (selectedModel.model_name === "Own Motorcycle") {
      return 0;
    }

    const selectedUpPrice = head(
      filter(
        propEq("price_item_sub_type", `tour_${selectedModel.upgrade_type}`),
        tourPrices
      )
    );
    return selectedUpPrice.price;
  }

  getStripeType(rental) {
    if (!isNil(rental.booking.tour_id) && rental.booking.tour_id > 0) {
      return rental.booking.p4m ? "p4m" : "tours";
    }
  }

  isUserStripe = (rental) => {
    let stripToUse = null;
    if (!isNil(rental)) {
      const stripeType = this.getStripeType(rental);
      if (stripeType !== "p4m") {
        stripToUse = prop(`stripe_${stripeType}`, rental.driver);
      }
    }
    return !isNil(stripToUse);
  };

  async getHolidays1() {
    const { location_id_1 } = this.state;
    return this.getHolidays(location_id_1);
  }

  async getHolidays2() {
    const { location_id_2 } = this.state;
    return this.getHolidays(location_id_2);
  }

  async getHolidays(locationId) {
    const { date_1, date_2 } = this.state;

    const dataProvider = await dataProviderFactory("rest");
    const holidays = dataProvider(GET_LIST, "holidays", {
      filter: {
        startDate: date_1,
        endDate: date_2,
        location_id: locationId,
      },

      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: { field: this.props.created_at, order: "DESC" },
    });

    return holidays;
  }

  async getVehicles() {
    const { rental, vehicle_model_1 } = this.state;
    const dataProvider = await dataProviderFactory("rest");
    const responseVehicles = await dataProvider(GET_LIST, "vehicles", {
      filter: {
        availability: true,
        tour_id: rental.booking.tour_id,
        vehicle_model_id: vehicle_model_1,
      },
      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: { field: "order", order: "ASC" },
    });
    return responseVehicles;
  }

  async fetchData() {
    const { id } = this.props.match.params;
    const dataProvider = await dataProviderFactory("rest");
    const responseRental = await dataProvider(GET_ONE, `tour-management`, {
      id,
    });

    const vehicleModels = await dataProvider(GET_LIST, "vehicle_models", {
      filter: { active: true, type: "2" },
      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: { field: "order", order: "ASC" },
    });

    const priceDate = path(['booking', 'price_date'], responseRental.data);

    const responseTourPrices = await this.getTourPrices(responseRental.data.booking.tour_id, priceDate);

    const responseLocations = await dataProvider(GET_LIST, "locations", {
      filter: { only_bases: "true" },
      pagination: {
        page: 1,
        perPage: 999,
      },
      sort: { field: this.props.created_at, order: "DESC" },
    });

    const gpsPrices = await this.gpsPrices(priceDate);
    const hollidays1 = this.getHolidays1();
    const hollidays2 = this.getHolidays2();
    const insurancePrices = await this.insurancePrices(priceDate);

    let rentalDays = this.duration(responseRental.data.date_1, responseRental.data.date_2);

    let effective_start = moment(responseRental.data.booking.tour.effective_start_date).utc()
    let effective_end = moment(responseRental.data.booking.tour.effective_end_date).utc()
    let efectiveDays = this.duration(effective_start, effective_end, true);
    
    let singlePrice = responseRental.data.booking.r_single ? prop("price",
      head(filter(propEq("price_item_sub_type", "tour_single"), responseTourPrices.data)))
      : 0;
    let cancelInsurancePercentage0 = responseRental.data.booking.r_cancel_insurance
      ? prop(
        "percentage",
        head(filter(propEq("price_item_id", 3), insurancePrices.data))
      )
      : 0;
    let tourTotal = prop(
      "price",
      head(filter(propEq("price_item_sub_type", "tour_total"), responseTourPrices.data))
    );
    let tourPassengerPrice = prop(
      "price",
      head(
        filter(propEq("price_item_sub_type", "tour_passenger"), responseTourPrices.data)
      )
    );


    const selectedModel = head(filter(propEq("id", responseRental.data.booking.vehicle_model_1), vehicleModels.data));
    let tourTotal1 = selectedModel.model_name === "Own Motorcycle" ? tourPassengerPrice : tourTotal;

    let gpsPrice = responseRental.data.booking.r_gps
      ? prop("price", head(
        filter(propEq("price_item_type", "gps_device"), gpsPrices.data)
      )) : 0;

    let passengerBooking = responseRental.data.booking
    let passengerPrice = !isNil(passengerBooking.p_first_name) ? tourPassengerPrice : 0;

    const initialInsId = normalizeInsuranceId(
      responseRental.data.booking.r_insurance_id != null
        ? responseRental.data.booking.r_insurance_id
        : responseRental.data.booking.r_insurance
    );
    const applicableInsId = resolveApplicableInsuranceId(initialInsId, efectiveDays);
    let vipInsurancePrice = dailyInsurancePriceFromList(
      insurancePrices.data,
      applicableInsId
    );

    this.setState(
      {
        driver_id: responseRental.data.driver.id,
        rewards: responseRental.data.booking.rewards,
        vehicle_model_1: responseRental.data.booking.vehicle_model_1,
        vehicle_model_2: responseRental.data.booking.vehicle_model_2,
        location_id_1: responseRental.data.location_id_1,
        location_id_2: responseRental.data.location_id_2,
        date_1: responseRental.data.date_1,
        date_2: responseRental.data.date_2,
        time_1: responseRental.data.time_1,
        time_2: responseRental.data.time_2,
        low_seat: responseRental.low_seat,
        gpsPrices: gpsPrices.data,
        hollidays1,
        hollidays2,
        insurancePrices: insurancePrices.data,
        r_single: responseRental.data.booking.r_single,
        r_double: !responseRental.data.booking.r_single,
        r_gps: responseRental.data.booking.r_gps,
        r_cancel_insurance: responseRental.data.booking.r_cancel_insurance,
        r_insurance_id: applicableInsId,
        r_insurance: isPaidInsurance(applicableInsId),
        rental: responseRental.data,
        locations: responseLocations.data,
        tourPrices: responseTourPrices.data,
        models: vehicleModels.data,
        priceDate,
        cancelInsurancePercentage: cancelInsurancePercentage0,
        tourData: responseRental.data.booking.tour,
        effective_start_date: responseRental.data.booking.tour.effective_start_date,
        effective_end_date: responseRental.data.booking.tour.effective_end_date,
        // chargeTypeId: this.isUserStripe(responseRental.data) ? "1" : "2"
      },

      async () => {
        const [
          vehicles,
          model1Price,
          model2Price,
          gpsDevices,
          clientRewards,
        ] = await Promise.all([
          this.getVehicles(),
          this.getModelPrices1(),
          this.getModelPrices2(),
          this.getGpsDevices(),
          this.getAvailableRewards(responseRental.data.driver.id),
        ]);


        let cancelInsuranceValue1 = ((tourTotal1 +
          gpsPrice * efectiveDays +
          passengerPrice +
          singlePrice +
          model1Price) *
          cancelInsurancePercentage0) /
          100;
        let dayActual = moment(Date.now()).format("YYYY-MM-DD")
        let rentalAheadSixtyDays = moment(responseRental.data.booking.tour.tour_start_date).diff(dayActual, "days") >= 60;
        let calculateDepositToCharge = rentalAheadSixtyDays
          ? 500 + (passengerPrice > 0 ? 500 : 0)
          : 0;
        if (responseRental.data.booking.r_cancel_insurance == false) 
        { 
          cancelInsuranceValue1 = 0
        }else{
          calculateDepositToCharge = calculateDepositToCharge + cancelInsuranceValue1
        }  
        let rentalTotal1 = cancelInsuranceValue1 + (tourTotal1 +
          (gpsPrice * efectiveDays) +
          (vipInsurancePrice * efectiveDays) +
          passengerPrice +
          singlePrice +
          model1Price + (this.getModelName1() == "Own Motorcycle" ? 500 : 0)) ;

        // si el tour es menor a 60 dias visualizar el cargo por 100%
        if (moment(responseRental.data.booking.tour.tour_start_date).diff(Date.now(), "days") < 60) {
          calculateDepositToCharge = rentalTotal1
        }
        this.setState({
          r_insurance_disabled: this.getModelName1() === "Own Motorcycle",
          r_gps_disabled: this.getModelName1() === "K1600GT",
          vehicles: vehicles.data,
          gpsDevices: gpsDevices.data,
          model1Price,
          model2Price,
          clientRewards,
          cancelInsuranceValue: cancelInsuranceValue1,
          value_to_charge: calculateDepositToCharge.toFixed(2)
        });
      }
    );
  }

  async recalcularSeguroCancelacion(){
    if(this.state.r_cancel_insurance){
      /**recalculando valor a cargar si tiene seguro de cancelacion */
        let rentalDays = this.duration(this.state.effective_start_date, this.state.effective_end_date, true);

        let dayActual = moment(Date.now()).format("YYYY-MM-DD")
        let rentalAheadSixtyDays = moment(this.state.rental.booking.tour.tour_start_date).diff(dayActual, "days") >= 60;
    
        let singlePrice = this.state.r_single ? prop("price",
          head(filter(propEq("price_item_sub_type", "tour_single"), this.state.tourPrices)))
          : 0;
    
        let tourTotal = prop(
          "price",
          head(filter(propEq("price_item_sub_type", "tour_total"), this.state.tourPrices))
        );
      
        let tourPassengerPrice = prop(
          "price",
          head(
            filter(propEq("price_item_sub_type", "tour_passenger"), this.state.tourPrices)
          )
        );
  
       let tourTotal1 = this.getModelName1() === "Own Motorcycle" ? tourPassengerPrice : tourTotal;
    
        let gpsPrice = this.state.r_gps
          ? prop("price", head(
            filter(propEq("price_item_type", "gps_device"), this.state.gpsPrices)
          )) : 0;
    
        let passengerPrice = !isNil(this.state.rental.booking.p_first_name)
          ? tourPassengerPrice
          : 0;
    
        let cancelInsurancePercentage0 = this.state.r_cancel_insurance
          ? prop(
            "percentage",
            head(filter(propEq("price_item_id", 3), this.state.insurancePrices))
          )
          : 0;
  
        let vipInsurancePrice = dailyInsurancePriceFromList(
          this.state.insurancePrices,
          resolveApplicableInsuranceId(this.state.r_insurance_id, rentalDays)
        );
  
        let model1Price
        if (this.state.model1Price != undefined || !isNaN(this.state.model1Price)) {
          model1Price = await this.getModelPrices1()
        }
  
        let cancelInsuranceValue1 = ((tourTotal1 +
          gpsPrice * rentalDays +
          passengerPrice +
          singlePrice +
          model1Price) *
          cancelInsurancePercentage0) /
          100
          
        let depositToCharge = 0
        //si cambia seguro de cancelacion true
        //calcula la cantidad de deposito
        let calculateDepositToCharge = rentalAheadSixtyDays
        ? 500 + (passengerPrice > 0 ? 500 : 0)
        : 0;
  
        depositToCharge =  calculateDepositToCharge + cancelInsuranceValue1

        this.setState({
          cancelInsurancePercentage: cancelInsurancePercentage0,
          cancelInsuranceValue: cancelInsuranceValue1, 
          value_to_charge : depositToCharge.toFixed(2)
        })
    }
  }

  async getValueTobeCharge() {
    let rentalDays = this.duration(this.state.effective_start_date, this.state.effective_end_date, true);

    let dayActual = moment(Date.now()).format("YYYY-MM-DD")
    let rentalAheadSixtyDays = moment(this.state.rental.booking.tour.tour_start_date).diff(dayActual, "days") >= 60;

    let singlePrice =this.state.r_single  ? prop("price",
      head(filter(propEq("price_item_sub_type", "tour_single"), this.state.tourPrices)))
      : 0;

    let tourTotal = prop(
      "price",
      head(filter(propEq("price_item_sub_type", "tour_total"), this.state.tourPrices))
    );

    let tourPassengerPrice = prop(
      "price",
      head(
        filter(propEq("price_item_sub_type", "tour_passenger"), this.state.tourPrices)
      )
    );

    let tourTotal1 = this.getModelName1() === "Own Motorcycle" ? tourPassengerPrice : tourTotal;

    let gpsPrice = this.state.r_gps
      ? prop("price", head(
        filter(propEq("price_item_type", "gps_device"), this.state.gpsPrices)
      )) : 0;

    let passengerPrice = !isNil(this.state.rental.booking.p_first_name)
      ? tourPassengerPrice
      : 0;

    let cancelInsurancePercentage0 = this.state.r_cancel_insurance
      ? prop(
        "percentage",
        head(filter(propEq("price_item_id", 3), this.state.insurancePrices))
      )
      : 0;

    let vipInsurancePrice = dailyInsurancePriceFromList(
      this.state.insurancePrices,
      resolveApplicableInsuranceId(this.state.r_insurance_id, rentalDays)
    );

    let model1Price
    if (this.state.model1Price != undefined || !isNaN(this.state.model1Price)) {
      model1Price = await this.getModelPrices1()
    }

    let cancelInsuranceValue1 = ((tourTotal1 +
      gpsPrice * rentalDays +
      passengerPrice +
      singlePrice +
      model1Price) *
      cancelInsurancePercentage0) /
      100
    let depositToCharge = 0
    //si cambia seguro de cancelacion true
    //calcula la cantidad de deposito
    let calculateDepositToCharge = rentalAheadSixtyDays
    ? 500 + (passengerPrice > 0 ? 500 : 0)
    : 0;

    if (this.state.r_cancel_insurance && notifiSeguroCancel == false) {
      notifiSeguroCancel = true
      let menssaje = `Seguro de cancelacion agregado: € ` + cancelInsuranceValue1
      depositToCharge =  calculateDepositToCharge + cancelInsuranceValue1
      if (!isNaN(cancelInsuranceValue1)) {
        notifiSeguroCancel = true
        this.setState({
          cancelInsurancePercentage: cancelInsurancePercentage0,
          cancelInsuranceValue: cancelInsuranceValue1,
          r_cancel_insurance: true,
          value_to_charge : depositToCharge.toFixed(2)
        })
        this.props.showNotification(menssaje, 'success')
      } 
    } 
    else if (this.state.rental.booking.r_cancel_insurance == false) 
    { 
      depositToCharge = calculateDepositToCharge
      notifiSeguroCancel = false
    }
    else if (this.state.r_cancel_insurance == false) 
    { 
      depositToCharge = calculateDepositToCharge
      notifiSeguroCancel = false
    }
    else{
      depositToCharge =  calculateDepositToCharge + cancelInsuranceValue1
      notifiSeguroCancel = true
    }  
      let rentalTotal1 = cancelInsuranceValue1 + (tourTotal1 +
        (gpsPrice * rentalDays) +
        (vipInsurancePrice * rentalDays) +
        passengerPrice +
        singlePrice +
        model1Price + (model1Price > 0 ? 0 : 500)) 

      // si el tour es menor a 60 dias visualizar el cargo por 100%
      if (moment(this.state.rental.booking.tour.tour_start_date).diff(Date.now(), "days") < 60) {
        depositToCharge = rentalTotal1
      }
      
      this.setState({
        value_to_charge : depositToCharge.toFixed(2)
      }) 
    
  }
  async getValueTobeChargeVip() {
    let rentalDays = this.duration(this.state.effective_start_date, this.state.effective_end_date, true);

    let vipInsurancePrice = dailyInsurancePriceFromList(
      this.state.insurancePrices,
      resolveApplicableInsuranceId(this.state.r_insurance_id, rentalDays)
    );
 
    //si cambia vip true
    if (isPaidInsurance(this.state.r_insurance_id) && notifiVip == false) {
      let menssaje = `${insuranceLabel(this.state.r_insurance_id)} agregado: € ` + (vipInsurancePrice * rentalDays)
      notifiVip = true
      if (!isNaN(vipInsurancePrice)) {
        notifiVip = true
        this.props.showNotification(menssaje, 'success')
      }

    } else { notifiVip = false }

  }
  async getValueTobeChargeGps() {
    let rentalDays = this.duration(this.state.effective_start_date, this.state.effective_end_date, true);

    let gpsPrice = this.state.r_gps
      ? prop("price", head(
        filter(propEq("price_item_type", "gps_device"), this.state.gpsPrices)
      )) : 0;

    //si cambia gps true
    if (this.state.r_gps && notifiGps == false) {
      let menssaje = `Dispositivo GPS agregado: € ` + (gpsPrice * rentalDays)
      notifiGps = true
      if (!isNaN(gpsPrice)) {
        notifiGps = true
        this.props.showNotification(menssaje, 'success')
      }
    } else { notifiGps = false }
    this.recalcularSeguroCancelacion()
  }
  async getValueTobeChargeSingle() { 
    let singlePrice = this.state.r_single ? prop("price",
      head(filter(propEq("price_item_sub_type", "tour_single"), this.state.tourPrices)))
      : 0;

    if (this.state.r_single && notifiSingle == false) {
      notifiSingle = true
      let menssaje = `Habitación sencilla agregado: € ` + singlePrice
      if (!isNaN(singlePrice)) {
        notifiSingle = true
        this.props.showNotification(menssaje, 'success')
      }
      
    } else { notifiSingle = false }
    this.recalcularSeguroCancelacion()
  }

  async componentDidUpdate(prevProps, prevState) {
    if (isNull(this.state.rental)) {
      await this.fetchData();
    }
    if (prevState.r_single !== this.state.r_single) {
      await this.getValueTobeChargeSingle();
      await this.getValueTobeCharge();
    }
    if (prevState.r_cancel_insurance !== this.state.r_cancel_insurance) {
      await this.getValueTobeCharge();
    }
    if (prevState.r_insurance !== this.state.r_insurance) {
      await this.getValueTobeChargeVip();
      await this.getValueTobeCharge();
    }
    if (prevState.r_gps !== this.state.r_gps) {
      await this.getValueTobeChargeGps();
      await this.getValueTobeCharge();
    }
  }

  async componentDidMount() {
    moment_tz.tz.setDefault("Europe/Madrid");
    if (isNull(this.state.rental)) {
      await this.fetchData();
    }
  }

  duration = (date1, date2, forEffectives = false) => {
    let days = moment.utc(date2).diff(date1, "days");
    if(forEffectives){
      days += 1
    }
    return days || 0;
  };

  getModelName = (modelId) => {
    const { models } = this.state;
    return prop("model_name", find(propEq("id", modelId), models));
  };

  handleCheckChange = (event, item) => {
    if (item === "r_double") {
      if (this.state.r_double) {
        this.setState({
          r_single: true,
          r_double: false,
        });
      } else {
        this.setState({
          r_single: false,
          r_double: true,
        });
      }
    }
    if (item === "r_single") {
      if (this.state.r_single) {
        this.setState({
          r_double: true,
          r_single: false,
        });
      } else {
        this.setState({
          r_double: false,
          r_single: true,
        });
      }
    }
    if (item === "r_cancel_insurance") {
      if (this.state.r_cancel_insurance) {
        this.setState({
          r_cancel_insurance: false,
        });
      } else {
        this.setState({
          r_cancel_insurance: true,
        });

        let cancelInsurancePercentage = this.state.r_cancel_insurance
          ? prop(
            "percentage",
            head(filter(propEq("price_item_id", 3), this.state.insurancePrices))
          )
          : 0;
        this.setState({
          cancelInsurancePercentage: cancelInsurancePercentage,
        });
      }
    }
    if (item === "r_gps") {
      if (this.state.r_gps) {
        this.setState({
          gpsDeviceId: 0,
          r_gps: false
        });
      } else {
        this.setState({
          gpsDeviceId: 0,
          r_gps: true
        });
      }
    }
    if (item === "low_seat") {
      if (this.state.low_seat) {
        this.setState({
          low_seat: false,
        });
      } else {
        this.setState({
          low_seat: true,
        });
      }
    }
    if (item === "r_insurance") {
      if (this.state.r_insurance) {
        this.setState({
          r_insurance: false,
        });
      } else {
        this.setState({
          r_insurance: true,
        });
      }
    }
    if (item === "noConfirmationEmail") {
      if (this.state.noConfirmationEmail) {
        this.setState({
          noConfirmationEmail: false,
        });
      } else {
        this.setState({
          noConfirmationEmail: true,
        });
      }
    }
  };

  handleChange = (element, type) => {
    this.setState({ [type]: element.target.value }, async () => {
      const [updatedVehicles, updatedGps] = await Promise.all([
        this.getVehicles(),
        this.getGpsDevices(),
      ]);

      this.setState({
        vehicleId: 0,
        gpsDeviceId: 0,
        vehicles: updatedVehicles.data,
        gpsDevices: updatedGps.data,
      });
    });
  };

  handleSaveClick = () => {
    const { submit } = this.props;
    this.setState({ isOnSubmit: true }, () => {
      submit("process-rental");
    });
  };

  rewardsNotOk = () => {
    return parseInt(this.state.rewards, 0) > parseInt(this.state.clientRewards, 0);
  };

  handleSubmit = async () => {
    const {
      discount,
      rental,
      vehicleId,
      date_1,
      date_2,
      time_1,
      time_2,
      r_single,
      imt_comment,
      location_id_1,
      location_id_2,
      chargeTypeId,
      low_seat,
      comments,
      gpsDeviceId,
      r_gps,
      r_insurance,
      r_insurance_id,
      r_cancel_insurance,
      vehicle_model_1,
      rewards,
      value_to_charge,
      noConfirmationEmail,
      priceDate,
      cancelInsuranceValue, checkedF
    } = this.state;

    const bodyRequest = {
      id: rental.id,
      data: {
        driver_id: rental.client_id,
        discount,
        vehicle_id: vehicleId,
        date_1,
        date_2,
        time_1,
        time_2,
        location_id_1,
        location_id_2,
        charge_type_id: chargeTypeId,
        comments,
        imt_comment,
        gpsdevice_id: gpsDeviceId,
        r_insurance: isPaidInsurance(r_insurance_id),
        r_insurance_id: normalizeInsuranceId(r_insurance_id),
        rewards,
        r_gps: this.getModelName1() === "K1600GT" ? true : r_gps,
        low_seat,
        r_single,
        vehicle_model_1,
        r_cancel_insurance,
        value_to_charge,
        noConfirmationEmail,
        priceDate,
        cancelInsuranceValue, checkedF
      },
    };
    const dataProvider = await dataProviderFactory("rest");
    dataProvider(UPDATE, "tour-management", bodyRequest)
      .then(() => {
        this.setState({
          availableItems: {},
          data: {},
          events: {},
          newItem: 0,
        });
        const { history } = this.props;
        history.replace("/tour-management");
      })
      .catch((error) => {
        this.setState({ isOnSubmit: false });
        this.props.showNotification(error.message, "error");
      });
  };

  isWeekEnd = (curDay) => {
    const date1 = moment(curDay);
    return date1.weekday() === 6 || date1.weekday() === 0;
  };

  isHoliday = (curDay, items) => {
    const hasHollidays = [];
    map((hd) => {
      const date1 = moment(hd.date).format("YYYY-MM-DD");
      const date2 = curDay.format("YYYY-MM-DD");
      if (date1 === date2 || curDay.weekday() === 6 || curDay.weekday() === 7) {
        hasHollidays.push(hd);
      }
    }, items || []);
    return length(hasHollidays) > 0;
  };

  handleCheckChangeConfirm = (event, valueToConfirm) => {
    if(this.state.checkedF){
      this.setState({ 
        checkedF : false
      });
    }else{
      this.setState({ 
        checkedF : true
      });
    }
   
    /*if (event.target.checked) {
      const value_to_charge = document.getElementById('value_to_charge');
      this.setState({ value_to_charge: (value_to_charge.value).toFixed(2) });
    }*/

    /*   if (!event.target.checked) {
        this.setState({ value_to_charge: valueToConfirm });
      } */
  };

  handleChangeItem = (element, type) => {
    this.setState({
      [type]: element.target.value,
    });
  };

  handleCalculateDepositToCharge = (rentalAheadSixtyDays, passengerPrice, cancelInsuranceValue1, startDate) => {
    let calculateDepositToCharge = rentalAheadSixtyDays
      ? 500 + (passengerPrice > 0 ? 500 : 0) + cancelInsuranceValue1
      : 0;

    if (moment(startDate).diff(Date.now(), "days") < 60) {
      calculateDepositToCharge = rentalTotal1
    }
    this.setState({
      value_to_charge: calculateDepositToCharge.toFixed(2),
    });
    return calculateDepositToCharge
  };

  handelModelChange = (element) => {
    this.setState(
      {
        vehicle_model_1: element.target.value,
        vehicles: [],
        model1Price: 0,
        model2Price: 0,
        vehicleId: 0,
        checkedF: false,
      },
      async () => {
        const updatedVehicles = await this.getVehicles();
        const updatedModelPrice1 = await this.getModelPrices1();
        const updatedModelPrice2 = await this.getModelPrices2();
        this.setState({
          vehicles: updatedVehicles.data,
          model1Price: updatedModelPrice1,
          model2Price: updatedModelPrice2,
          r_insurance_disabled: this.getModelName1() === "Own Motorcycle",
          r_gps_disabled: this.getModelName1() === "K1600GT",
          r_insurance_id:
            this.getModelName1() === "Own Motorcycle"
              ? INSURANCE_REGULAR
              : this.state.r_insurance_id,
          r_insurance:
            this.getModelName1() === "Own Motorcycle"
              ? false
              : isPaidInsurance(this.state.r_insurance_id),
          gpsDeviceId:
            this.getModelName1() === "K1600GT" ? 0 : this.state.gpsDeviceId,
        });
        this.getValueTobeCharge();
      }
    );
    
  };

  handlePriceDateChange = (event) => {
    const newPriceDate = event.target.value;
    this.setState({ priceDate: newPriceDate }, async () => {
      const { rental } = this.state;

      const responseTourPrices = await this.getTourPrices(rental.booking.tour_id, newPriceDate);
      const gpsPrices = await this.gpsPrices(newPriceDate);
      const insurancePrices = await this.insurancePrices(newPriceDate);

      this.setState({
        gpsPrices: gpsPrices.data,
        insurancePrices: insurancePrices.data,
        tourPrices: responseTourPrices.data,
      }, async () => {
        const [
          model1Price,
          model2Price,
        ] = await Promise.all([
          this.getModelPrices1(),
          this.getModelPrices2(),
        ]);

        this.setState({
          model1Price,
          model2Price,
        });
      });
    });
  };

  validateDates = () => {
    const { date_1, date_2 } = this.state;
    const d2 = moment(date_2);
    const d1 = moment(date_1);
    return d2.isAfter(d1);
  };

  chargeTypeId = (rental) => {
    const chargeTypes = [
      { _id: "1", description: "Stripe" },
      { _id: "2", description: "Other (Money, bank transfer)" },
    ];
    return (
      <div>
        <InputLabel htmlFor="charge-simple">Charge Type</InputLabel> <br />
        <StyledSelect
          onChange={(e) => this.handleChangeItem(e, "chargeTypeId")}
          inputProps={{
            name: "charge",
            id: "charge-simple",
          }}
          value={this.state.chargeTypeId}
          disabled={!this.isUserStripe(rental) || rental.booking.p4m}
        >
          {map((item) => {
            return (
              <MenuItem key={item._id} value={item._id}>
                {item.description}
              </MenuItem>
            );
          }, chargeTypes)}
        </StyledSelect>
        <br />
      </div>
    );
  };

  checkOneDay = (bike) => {
    let nextDay = new Date(Date.parse(bike.date_2));
    nextDay.setDate(nextDay.getDate() + 1);
    if (nextDay.toISOString().slice(0, 10) == this.state.date_1) {
      return true
    } else {
      return false
    }
  }

  render() {
    if (isNil(this.state.rental) || isNil(this.state.vehicles)) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    const {
      rental,
      models,
      vehicles,
      gpsDevices,
      model1Price,
      model2Price,
      date_1,
      date_2,
      gpsPrices,
      insurancePrices,
      r_cancel_insurance,
      r_insurance,
      r_gps,
      r_single,
      discount,
      hollidays1,
      hollidays2,
      isOnSubmit,
      tourPrices,
      rewards,
      priceDate, cancelInsurancePercentage, value_to_charge
    } = this.state;

    let gpsPrice = 0;
    let singlePrice = 0;
    let tourTotal = 0;
    let rentalTotal2 = 0;
    let vipInsurancePrice = 0;
    let passengerPrice = 0;
    let tourPassengerPrice = 0;
    let cancelInsurancePercentage0 = 0;
    let cancelInsuranceValue1 = 0;
    let cancelInsuranceValue2 = 0;
    let calculateDepositToCharge = 0;
    let rentalAheadSixtyDays = false;

    let rentalDays = this.duration(rental.booking.tour.tour_start_date, rental.booking.tour.tour_end_date, true);

    let effective_start = moment(rental.booking.tour.effective_start_date).utc()
    let effective_end = moment(rental.booking.tour.effective_end_date).utc()
    let efectiveDays = this.duration(effective_start, effective_end, true)

    if (rentalDays > 0 && !isNil(rentalDays)) {
      singlePrice = r_single
        ? prop(
          "price",
          head(
            filter(propEq("price_item_sub_type", "tour_single"), tourPrices)
          )
        )
        : 0;

      tourTotal = prop(
        "price",
        head(filter(propEq("price_item_sub_type", "tour_total"), tourPrices))
      );

      tourPassengerPrice = prop(
        "price",
        head(
          filter(propEq("price_item_sub_type", "tour_passenger"), tourPrices)
        )
      );

      passengerPrice = !isNil(rental.booking.p_first_name)
        ? tourPassengerPrice
        : 0;

      const isBeforeDate1 = curry((date1, item) => {
        return moment(item.start_date).isBefore(moment(date1));
      });

      gpsPrice = r_gps
        ? prop(
          "price",
          head(
            filter(propEq("price_item_type", "gps_device"), gpsPrices)
          )
        )
        : 0;

      vipInsurancePrice = dailyInsurancePriceFromList(
        insurancePrices,
        resolveApplicableInsuranceId(this.state.r_insurance_id, efectiveDays)
      );

      cancelInsurancePercentage0 = r_cancel_insurance
        ? prop(
          "percentage",
          head(filter(propEq("price_item_id", 3), insurancePrices))
        )
        : 0;

      let tourTotal1 =
        this.getModelName1() === "Own Motorcycle"
          ? tourPassengerPrice
          : tourTotal;

      cancelInsuranceValue1 = r_cancel_insurance
        ? ((tourTotal1 +
          gpsPrice * efectiveDays + //cambiamos rentalDays por efectiveDays
          passengerPrice +
          singlePrice +
          model1Price) *
          cancelInsurancePercentage) /
        100
        : 0;

      let dayActual = moment(Date.now()).format("YYYY-MM-DD")

      rentalAheadSixtyDays = moment(rental.booking.tour.tour_start_date).diff(dayActual, "days") >= 60;

      calculateDepositToCharge = rentalAheadSixtyDays
        ? 500 + (passengerPrice > 0 ? 500 : 0)
        : 0;

      calculateDepositToCharge = calculateDepositToCharge + cancelInsuranceValue1
      

      rentalTotal1 =
        cancelInsuranceValue1 +
        (tourTotal1 +
          gpsPrice * efectiveDays + //cambiamos rentalDays por efectiveDays
          vipInsurancePrice * efectiveDays + //cambiamos rentalDays por efectiveDays
          passengerPrice +
          singlePrice +
          model1Price + (model1Price > 0 ? 0 : 500)) - rewards - discount;

      // si el tour es menor a 60 dias visualizar el cargo por 100%
      if (moment(rental.booking.tour.tour_start_date).diff(Date.now(), "days") < 60) {
        calculateDepositToCharge = rentalTotal1
      }

      let tourTotal2 =
        this.getModelName2() === "Own Motorcycle"
          ? tourPassengerPrice
          : tourTotal;

      cancelInsuranceValue2 = r_cancel_insurance
        ? ((tourTotal2 +
          gpsPrice * efectiveDays + //cambiamos rentalDays por efectiveDays
          passengerPrice +
          singlePrice +
          model2Price) *
          // -
          // discount -
          // rewards) *
          cancelInsurancePercentage) /
        100
        : 0;

      rentalTotal2 =
        cancelInsuranceValue2 +
        (tourTotal2 +
          gpsPrice * efectiveDays + //cambiamos rentalDays por efectiveDays
          vipInsurancePrice * efectiveDays + //cambiamos rentalDays por efectiveDays
          passengerPrice +
          singlePrice +
          model2Price) -
        rewards -
        discount;
    //     console.log("tourTotal1", tourTotal1)
    //       console.log("tourTotal2", tourTotal2)
    //       console.log("passenger", passengerPrice);
    //       console.log("singlePrice", singlePrice);
    //       console.log("modelprice_1", model1Price);
    //       console.log("model_2_price", model2Price);
    }

    return (
      <Card>
        <CardContent>
          <Typography
            gutterBottom
            variant="display3"
            component="h2"
            style={styles.cardHeaderStyle}
          >
            Processing Tour Booking For:{" "}
            <b>
              {rental.booking.r_first_name} {rental.booking.r_last_name}
            </b>
          </Typography>
          <br />
          <Responsive
            medium={
              <div>
                <div style={styles.flex}>
                  <div style={styles.leftColB}>
                    <div style={styles.flexB}>
                      <SimpleForm
                        style={{ width: "100%" }}
                        form="process-rental"
                        onSubmit={this.handleSubmit}
                        toolbar={null}
                      >
                        <FormControlLabel
                          control={
                            <Switch
                              name="r_gps"
                              id="r_gps"
                              checked={this.state.r_gps}
                              onChange={(e) => this.handleCheckChange(e, 'r_gps')}
                              value="0"
                              color="primary"
                              disabled={this.state.r_gps_disabled}
                            />
                          }
                          label="GPS"
                        />
                        <InputLabel htmlFor="r_insurance_id">Insurance</InputLabel>
                        <StyledSelect
                          name="r_insurance_id"
                          id="r_insurance_id"
                          value={this.state.r_insurance_id}
                          disabled={this.state.r_insurance_disabled}
                          onChange={e => {
                            const id = normalizeInsuranceId(e.target.value);
                            this.setState(
                              {
                                r_insurance_id: id,
                                r_insurance: isPaidInsurance(id),
                              },
                              () => {
                                this.getItemsPrices && this.getItemsPrices();
                                this.getValueTobeChargeVip && this.getValueTobeChargeVip();
                              }
                            );
                          }}
                        >
                          {insuranceSelectChoices(efectiveDays).map(opt => (
                            <MenuItem
                              key={opt.id}
                              value={opt.id}
                              disabled={!!opt.disabled}
                            >
                              {opt.name}
                            </MenuItem>
                          ))}
                        </StyledSelect>
                        <FormControlLabel
                          control={
                            <Switch
                              name="r_cancel_insurance"
                              id="r_cancel_insurance"
                              checked={this.state.r_cancel_insurance}
                              onChange={(e) => this.handleCheckChange(e, 'r_cancel_insurance')}
                              value="0"
                              color="primary"
                            />
                          }
                          label="Cancel Insurance"
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              name="low_seat"
                              id="low_seat"
                              checked={this.state.low_seat}
                              onChange={(e) => this.handleCheckChange(e, 'low_seat')}
                              value="0"
                              color="primary"
                            />
                          }
                          label="Low Seat"
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              name="r_single"
                              id="r_single"
                              checked={this.state.r_single}
                              onChange={(e) => this.handleCheckChange(e, 'r_single')}
                              value="0"
                              color="primary"
                            />
                          }
                          label="Single"
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              name="r_double"
                              id="r_double"
                              checked={this.state.r_double}
                              onChange={(e) => this.handleCheckChange(e, 'r_double')}
                              value="0"
                              color="primary"
                            />
                          }
                          label="Double"
                        />
                        <br />
                        <TextField
                          id="priceDate"
                          label="Applicable Price Date"
                          type="date"
                          onChange={e => this.handlePriceDateChange(e)}
                          defaultValue={moment.utc(priceDate).format(
                            "YYYY-MM-DD"
                          )}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                        <br />
                        <InputLabel shrink htmlFor="model-simple">
                          Model
                        </InputLabel>
                        <StyledSelect
                          onChange={this.handelModelChange}
                          inputProps={{
                            name: "model",
                            id: "model-simple",
                          }}
                          value={this.state.vehicle_model_1}
                        >
                          {map((item) => {
                            return (
                              <MenuItem value={item.id} key={item.id}>
                                {item.model_name}
                              </MenuItem>
                            );
                          }, models)}
                        </StyledSelect>

                        <br />
                        <InputLabel shrink htmlFor="bike-simple">
                          Motorcycle *
                        </InputLabel>
                        <StyledSelect
                          onChange={(e) =>
                            this.handleChangeItem(e, "vehicleId")
                          }
                          inputProps={{
                            name: "bike",
                            id: "bike-simple",
                          }}
                          value={this.state.vehicleId}
                        >
                          {map((item) => {
                            if (item.date_2.slice(0, 10) == date_1 || this.checkOneDay(item)) {
                              return (<MenuItem value={item.id} key={item.id}>
                                /!\** {item.licence_plate} {item.renting ? "®" : ""} ({item.vehicle_color} /{" "}
                                {item.vehicle_mileage} kms) **/!\
                              </MenuItem>)
                            } else {
                              return (<MenuItem value={item.id} key={item.id}>
                                {item.licence_plate} {item.renting ? "®" : ""} ({item.vehicle_color} /{" "}
                                {item.vehicle_mileage} kms)
                              </MenuItem>)
                            }
                          }, vehicles)}
                        </StyledSelect>
                        {this.state.vehicleId === 0 &&
                          this.getModelName1() !== "Own Motorcycle" && (
                            <StyledSpan>* Please select Motorcycle</StyledSpan>
                          )}

                        <br />
                        {!this.state.r_gps_disabled && this.state.r_gps && (
                          <React.Fragment>
                            <InputLabel shrink htmlFor="gps-simple">
                              Gps Device *
                            </InputLabel>{" "}
                            <br />
                            <StyledSelect
                              onChange={(e) =>
                                this.handleChangeItem(e, "gpsDeviceId")
                              }
                              inputProps={{
                                name: "gps",
                                id: "gps-simple",
                              }}
                              value={this.state.gpsDeviceId}
                            >
                              {map((item) => {
                                return (
                                  <MenuItem value={item.id} key={item.id}>
                                    {item.model}
                                  </MenuItem>
                                );
                              }, gpsDevices)}
                            </StyledSelect>
                            {this.state.gpsDeviceId === 0 &&
                              this.state.r_gps && (
                                <StyledSpan>
                                  * Please select GPS device
                                </StyledSpan>
                              )}
                          </React.Fragment>
                        )}

                        {moment(rental.booking.tour.tour_start_date).diff(
                          Date.now(),
                          "days"
                        ) < 0 && (
                            <p>Value to be charged: {rentalTotal1.toFixed(2)}€</p>
                          )}
                        {moment(rental.booking.tour.tour_start_date).diff(
                          Date.now(),
                          "days"
                        ) > 0 && (
                            <React.Fragment>
                              <InputLabel shrink htmlFor="gps-simple">
                                Value to be charged €
                              </InputLabel>
                              {"  "}
                              <TextField
                                id="value_to_charge"
                                type="number"
                                onChange={(e) =>
                                  this.handleChangeItem(e, "value_to_charge")
                                }
                                value={ rentalAheadSixtyDays == true 
                                  ? this.state.value_to_charge
                                  : this.state.value_to_charge - this.state.rewards - this.state.discount
                                }
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="checkedF"
                                    checked={this.state.checkedF}
                                    onChange={(e) =>
                                      this.handleCheckChangeConfirm(e, "checkedF")
                                    }
                                    value="checkedF"
                                  />
                                }
                                label="Confirm value to be charged!"
                              />
                                { this.state.value_to_charge < cancelInsuranceValue1 && (
                                      <StyledSpan>
                                      * Invalid Value to be charged
                                      </StyledSpan>
                               )}  
                            </React.Fragment>
                          )}

                          <p>
                            <b>Available Rewards: {this.state.clientRewards}</b>
                          </p>
                          <TextField
                            id="rewards"
                            label="Rewards requested to use"
                            type="number"
                            onChange={(e) => this.handleChangeItem(e, "rewards")}
                            disabled={this.state.tourData.tour_category_id == 3}
                            defaultValue={this.state.rewards}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                          {this.rewardsNotOk() && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "17px",
                              }}
                            >
                              <b>Requested rewards are not available!</b>
                            </span>
                          )}
                        <br />
                        <TextField
                          id="discount"
                          label="Discount"
                          type="number"
                          onChange={(e) => this.handleChangeItem(e, "discount")}
                          defaultValue={this.state.discount}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <br />
                        {this.chargeTypeId(rental)}
                        <br />

                        {rental.from_agency && (
                          <StyledP
                            addLabel={false}
                            render={() => {
                              return "A pay link will be sent to the agency";
                            }}
                          />
                        )}
                        <br />
                        <TextField
                          fullWidth multiline
                          id="imt_comment"
                          label="IMT Comments (if charge type not Stripe)"
                          type="text"
                          onChange={(e) =>
                            this.handleChangeItem(e, "imt_comment")
                          }
                          defaultValue={this.state.imt_comment}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </SimpleForm>
                    </div>
                    <CardContent>
                      <Grid container spacing={24} alignItems="center">
                        <Grid item>
                          <SaveButton
                            onClick={this.handleSaveClick}
                            disabled={
                              (![1, 2, 4, 6, 9].includes(getPermissionRole())) ||
                              isOnSubmit ||
                              this.state.clientRewards < this.state.rewards ||
                              (this.state.value_to_charge < 0 && 
                                rentalAheadSixtyDays) ||
                              (!this.state.checkedF && this.state.checkedF == false) ||
                              (this.state.vehicleId === 0 &&
                                this.getModelName1() !== "Own Motorcycle") ||
                              (this.state.gpsDeviceId === 0 && this.state.r_gps && this.getModelName1() !== "K1600GT")
                            }
                            saving={isOnSubmit}
                          />
                        </Grid>
                        <Grid item>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="noConfirmationEmail"
                                checked={this.state.noConfirmationEmail}
                                onChange={e => this.handleCheckChange(e, 'noConfirmationEmail')}
                                value="noConfirmationEmail"
                              />
                            }
                            label="Don't send confirmation e-mail"
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </div>
                  <div style={styles.rightCol}>
                    <div style={styles.flex}>
                      <Card>
                        <CardContent>
                          <SimpleForm toolbar={null}>
                            <InputLabel shrink style={{ textAlign: "center" }}>
                              Choices & Prices
                            </InputLabel>
                            <FunctionField
                              label="Booking Date"
                              render={() => {
                                return moment.utc(
                                  rental.booking.r_timestamp
                                ).format(DATEFORMAT + " HH:mm:ss");
                              }}
                            />
                            <FunctionField
                              label="Tour"
                              render={() => {
                                return rental.booking.tour.tour_name
                                  .tour_name_en;
                              }}
                            />
                            <FunctionField
                              label="P4M"
                              render={() => {
                                if (rental.booking.p4m) {
                                  return "Yes";
                                } else {
                                  return "No";
                                }
                              }}
                            />
                            <FunctionField
                              label="Tour Start Date"
                              render={() => {
                                let date1 = `${moment.utc(
                                  rental.booking.tour.tour_start_date
                                ).format("DD, dddd, MMM YYYY")}`;
                                if (
                                  this.isHoliday(moment(date1), hollidays1) ||
                                  this.isWeekEnd(date_1)
                                ) {
                                  return (
                                    <div>
                                      {date1}
                                      <span
                                        style={{
                                          color: "red",
                                          fontSize: "17px",
                                        }}
                                      >
                                        &nbsp;<b>!</b>
                                      </span>
                                    </div>
                                  );
                                }
                                return date1;
                              }}
                            />
                            <FunctionField
                              label="Tour End Date"
                              render={() => {
                                let date2 = `${moment.utc(
                                  rental.booking.tour.tour_end_date
                                ).format("DD, dddd, MMM YYYY")}`;
                                if (
                                  this.isHoliday(moment(date_2), hollidays2) ||
                                  this.isWeekEnd(date_2)
                                ) {
                                  return (
                                    <div>
                                      {date2}
                                      <span
                                        style={{
                                          color: "red",
                                          fontSize: "17px",
                                        }}
                                      >
                                        &nbsp;<b>!</b>
                                      </span>
                                    </div>
                                  );
                                }
                                return date2;
                              }}
                              y
                            />
                            <FunctionField
                              label="Rider days (based on effective days)"
                              render={() => {
                                return `${efectiveDays > 0 ? efectiveDays : 0
                                  } days`;
                              }}
                            />
                            {r_gps && (
                              <FunctionField
                                label="Gps"
                                render={() => {
                                  return `${efectiveDays * gpsPrice
                                    } Euros (${gpsPrice} Euros/day)`;
                                }}
                              />
                            )}
                            {isPaidInsurance(this.state.r_insurance_id) && (
                              <FunctionField
                                label={`${insuranceLabel(this.state.r_insurance_id)} Insurance`}
                                render={() => {
                                  return `${efectiveDays * vipInsurancePrice
                                    } Euros (${vipInsurancePrice} Euros/day)`;
                                }}
                              />
                            )}

                            {r_cancel_insurance && (
                              <FunctionField
                                label="Cancel Insurance"
                                render={() => {
                                  return `Yes (${cancelInsuranceValue1.toFixed(
                                    2
                                  )} Euros)`;
                                }}
                              />
                            )}

                            <FunctionField
                              label="Rewards Used"
                              render={() => {
                                return `${rental.booking.rewards} points`;
                              }}
                            />
                            <FunctionField
                              label="First Choice Motorcycle"
                              render={() => {
                                return this.getModelName(
                                  rental.booking.vehicle_model_1
                                );
                              }}
                            />
                            <FunctionField
                              label="Second Choice Motorcycle"
                              render={() => {
                                return this.getModelName(
                                  rental.booking.vehicle_model_2
                                );
                              }}
                            />

                            {!isNil(rental.booking.p_first_name) && (
                              <FunctionField
                                label="Passenger"
                                render={() => {
                                  return `${rental.booking.p_first_name} ${rental.booking.p_last_name}`;
                                }}
                              />
                            )}

                            {!isNil(rental.booking.roommate) && (
                              <FunctionField
                                label="Roommate name"
                                render={() => {
                                  return `${rental.booking.roommate}`;
                                }}
                              />
                            )}

                            <FunctionField
                              label="Cost for first choice motorcycle"
                              render={() => {
                                return `${model1Price} Euros`;
                              }}
                            />
                            <FunctionField
                              label="Cost for second choice motorcycle"
                              render={() => {
                                return `${model2Price} Euros`;
                              }}
                            />
                            <FunctionField
                              label="First choice of motorcycle"
                              render={() => {
                                return `${rentalTotal1.toFixed(2)} Euros`;
                              }}
                            />
                            <FunctionField
                              label="Second choice of motorcycle"
                              render={() => {
                                return `${rentalTotal2.toFixed(2)} Euros`;
                              }}
                            />
                            <FunctionField
                              label="Comments"
                              render={() => {
                                return rental.booking.r_comments;
                              }}
                            />
                            <FunctionField
                              label="Client Passport"
                              render={() => {
                                const passport = rental.booking && Number(rental.booking.is_for) === 2
                                  ? rental.booking.r_passport
                                  : rental.driver.passport;
                                return `${isNil(passport) ? "N/A" : passport}`;
                              }}
                            />
                            <FunctionField
                              label="Driving Licence"
                              render={() => {
                                const licence = rental.booking && Number(rental.booking.is_for) === 2
                                  ? rental.booking.r_license
                                  : rental.driver.driving_licence;
                                return `${isNil(licence) ? "N/A" : licence}`;
                              }}
                            />
                            <FunctionField
                              label="Card Data"
                              render={() => {
                                return `${isNil(rental.clientData)
                                  ? "N/A"
                                  : rental.clientData
                                  }`;
                              }}
                            />
                          </SimpleForm>
                        </CardContent>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
            }
          />
        </CardContent>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  state: state,
});

const mapDispatchToProps = {
  change,
  showNotification,
  submit,
};

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(ProcessTour)
);



// WEBPACK FOOTER //
// ./src/components/processTour.js